import React, { useState } from 'react';
import { COLORS } from '../utils/constants.js';

export default function Companies({ addNotification }) {
  const [search, setSearch] = useState({ name: '', keywords: '', locations: '', employees: '' });
  const [enrichDomain, setEnrichDomain] = useState('');

  const fields = [
    { key: 'name', label: 'Company Name', placeholder: 'e.g. Stripe' },
    { key: 'keywords', label: 'Industry Keywords', placeholder: 'e.g. SaaS, fintech' },
    { key: 'locations', label: 'HQ Location', placeholder: 'e.g. San Francisco, CA' },
    { key: 'employees', label: 'Employee Range', placeholder: 'e.g. 51,200' },
  ];

  return (
    <div>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4 }}><span style={{ color: COLORS.green }}>▣</span> Company Research</h2>
      <p style={{ color: COLORS.textMuted, fontSize: 13, marginBottom: 20 }}>Search and enrich company data from Apollo</p>

      <div style={{ padding: 20, borderRadius: 12, background: COLORS.surface, border: `1px solid ${COLORS.border}`, marginBottom: 20 }}>
        <h3 style={{ margin: '0 0 14px', fontSize: 14, fontWeight: 600 }}>Search Companies</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 }}>
          {fields.map((f) => (
            <div key={f.key}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: COLORS.textDim, marginBottom: 4, textTransform: 'uppercase', letterSpacing: 1 }}>{f.label}</label>
              <input value={search[f.key]} onChange={(e) => setSearch((p) => ({ ...p, [f.key]: e.target.value }))} placeholder={f.placeholder} style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: `1px solid ${COLORS.border}`, background: COLORS.surfaceAlt, color: COLORS.text, fontSize: 13 }} />
            </div>
          ))}
        </div>
        <button onClick={() => addNotification('Company search via Apollo MCP — use chat', 'info')} style={{ marginTop: 16, padding: '10px 24px', borderRadius: 8, border: 'none', background: `linear-gradient(135deg, ${COLORS.green}, ${COLORS.greenDim})`, color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Search Companies</button>
      </div>

      <div style={{ padding: 20, borderRadius: 12, background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
        <h3 style={{ margin: '0 0 14px', fontSize: 14, fontWeight: 600 }}>Enrich Company Data</h3>
        <p style={{ fontSize: 12, color: COLORS.textMuted, margin: '0 0 12px' }}>Enter a domain for enriched company data.</p>
        <div style={{ display: 'flex', gap: 12 }}>
          <input value={enrichDomain} onChange={(e) => setEnrichDomain(e.target.value)} placeholder="e.g. stripe.com" style={{ flex: 1, padding: '10px 12px', borderRadius: 8, border: `1px solid ${COLORS.border}`, background: COLORS.surfaceAlt, color: COLORS.text, fontSize: 13 }} />
          <button onClick={() => addNotification(`Enrichment for ${enrichDomain} — use Apollo MCP in chat`, 'info')} style={{ padding: '10px 20px', borderRadius: 8, border: 'none', background: `linear-gradient(135deg, ${COLORS.accent}, ${COLORS.accentDim})`, color: COLORS.bg, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Enrich</button>
        </div>
        <p style={{ fontSize: 11, color: COLORS.textDim, margin: '8px 0 0' }}>⚡ Uses credits — confirm before proceeding</p>
      </div>
    </div>
  );
}
